import { useState, type ReactNode } from 'react';

const FONTES = ['./branding/capa.jpeg', './branding/capa.jpg', './branding/capa.png', './branding/capa.webp'];

interface Props {
  /** Botões sobre a capa (Tutorial, link…). */
  acoes?: ReactNode;
  /** Altura do banner. */
  alturaClassName?: string;
}

/** Cabeçalho só com a imagem da marca (sem texto Programa / nome). */
export default function BarbeariaCabecalhoMarca({
  acoes,
  alturaClassName = 'h-56 sm:h-64',
}: Props) {
  const [idx, setIdx] = useState(0);
  const temImg = idx < FONTES.length;

  return (
    <header
      className={`relative overflow-hidden border border-stone-900/10 shadow-[0_8px_24px_rgba(28,25,23,0.08)] ${alturaClassName} ${
        temImg ? 'bg-neutral-900' : 'bg-gradient-to-br from-neutral-950 via-neutral-900 to-amber-900'
      }`}
      style={{ borderRadius: '1.35rem' }}
    >
      {temImg ? (
        <img
          src={FONTES[idx]}
          alt=""
          className="absolute inset-0 h-full w-full object-cover object-center"
          onError={() => setIdx((i) => i + 1)}
        />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center px-4 text-center text-sm font-bold text-amber-100/90">
          Coloque a imagem em public/branding/capa.png
        </div>
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-transparent to-black/20" />
      {acoes ? (
        <div className="absolute right-2 top-2 z-10 flex flex-wrap justify-end gap-2 sm:right-3 sm:top-3">
          {acoes}
        </div>
      ) : null}
    </header>
  );
}
